import { useCallback } from "react";
import { UnsplashImageResponse } from "chq";
import { useSignUpload } from "app/hooks";
import { downloadPhoto } from "app/utils/unsplash";
import { Media, SetState } from "../types";


interface UploadImageProps {
  setState: SetState;
}

const useUploadImages = ({ setState }: UploadImageProps) => {
  const signUpload = useSignUpload();

  return useCallback(
    async (images: (Media & UnsplashImageResponse)[]) => {
      const imagesProgress = images.map(_ => 0);
      const processedUrls = await Promise.all(
        images.map(async (image, index: number) => {
          // existing stories and files that were not changed
          if (image.id && typeof image.id === "number") {
            return image;
          }

          // local files
          if (image.size) {
            const mediaUrl = await signUpload(
              image,
              (mediaProgress: number) => {
                imagesProgress[index] = (mediaProgress * 9) / (images.length * 10);
                setState({
                  progress: imagesProgress.reduce(
                    (progress: number, current: number) => progress + current,
                    0
                  )
                });
              }
            );
            return {
              mediaUrl
            };
          }

          // unsplash images
          const { urls } = image;
          if (urls) {
            downloadPhoto(image);

            return {
              mediaUrl: urls.regular,
              thumbUrl: urls.thumb,
              fullUrl: urls.full,
              smallUrl: urls.small,
              imageAlt: image.alt_description,
              width: image.width,
              height: image.height
            };
          }

          return {};
        })
      );

      return processedUrls;
    },
    [setState, signUpload]
  );
};

export default useUploadImages;
